import * as React from "react";
import { useMemo } from "react";

import { List } from "affinityUI/data/list";
import { useAuth } from "lib/auth";
import { PERMISSIONS } from "lib/biot/roles/types";
import { PatientsListEntry } from "types/patient";

import { PatientCard } from "./patientCard";
import { ResultCard } from "./resultCard";

const isPatientListEntry = (element: PatientsListEntry | null | undefined): element is PatientsListEntry =>
  element !== null && element !== undefined;

export const PatientsView: React.FC<{
  patients?: Array<PatientsListEntry | null | undefined> | null | undefined;
}> = ({ patients }) => {
  const [{ isPermitted }] = useAuth();

  const resultsPermitted = useMemo(() => isPermitted([PERMISSIONS.RESULT_DATA_VIEW]), [isPermitted]);

  return patients ? (
    <List>
      {patients
        .filter(isPatientListEntry)
        .map((patient) =>
          resultsPermitted ? (
            <ResultCard key={patient.id} patient={patient} />
          ) : (
            <PatientCard key={patient.id} patient={patient} />
          )
        )}
    </List>
  ) : (
    <p>No patients available</p>
  );
};
